import { render, staticRenderFns } from "./HeadRegister.vue?vue&type=template&id=c17fde78&scoped=true&"
import script from "./HeadRegister.vue?vue&type=script&lang=js&"
export * from "./HeadRegister.vue?vue&type=script&lang=js&"
import style0 from "./HeadRegister.vue?vue&type=style&index=0&id=c17fde78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17fde78",
  null
  
)

export default component.exports